import { OFButton } from "design_system/components/OFButton";
import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";
import { COUNTRY_CODES } from "src/constants/Countries";

const country = process.env.NEXT_PUBLIC_COUNTRY;

interface Props {
  t: (key: string) => string;
  onClick?: (product: any) => void;
  [rest: string]: any;
  requiresPrescription?: boolean;
}

export const AddButton = ({ t, onClick, requiresPrescription, ...rest }: Props) => {
  return (
    <OFButton onClick={onClick} {...rest}>
      <OFText textStyle="button1" color={colors.white.default}>
        {t(
          `shop:${
            country === COUNTRY_CODES.HK || requiresPrescription ? "add-to-list" : "add-to-cart"
          }`
        )}
      </OFText>
    </OFButton>
  );
};

export const BuyButton = ({ t, requiresPrescription, onClick, ...rest }: Props) => {
  return (
    <OFButton variant="primary" onClick={onClick} {...rest}>
      <OFText textStyle="button1" color={colors.white.default}>
        {t(`shop:${country === COUNTRY_CODES.HK || requiresPrescription ? "request" : "buy-now"}`)}
      </OFText>
    </OFButton>
  );
};
